// Shared ActionCable consumer. Reads the URL from the
// <meta name="action-cable-url"> tag emitted by action_cable_meta_tag, falling
// back to /cable. Creating the consumer once and reusing it across pages
// avoids opening duplicate WebSocket connections per Inertia navigation.
import { createConsumer } from '@rails/actioncable';

let consumer = null;

export function getCableConsumer() {
  if (consumer) return consumer;
  const meta = document.querySelector('meta[name="action-cable-url"]');
  const url = meta?.getAttribute('content') || '/cable';
  consumer = createConsumer(url);
  return consumer;
}
